import { IsOptional, IsUUID, IsIn } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { OffsetPaginationQueryDto, SortOrder } from '@sphere/shared/domain';

export class ListAttemptsRequestDto extends OffsetPaginationQueryDto {
  // Hérite de: page, limit, sort, order, q

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par activité' })
  @IsOptional()
  @IsUUID('4')
  activityId?: string;

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par utilisateur' })
  @IsOptional()
  @IsUUID('4')
  userId?: string;

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par classe' })
  @IsOptional()
  @IsUUID('4')
  classId?: string;

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par enseignement' })
  @IsOptional()
  @IsUUID('4')
  teachingId?: string;

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par établissement' })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string;

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par leçon' })
  @IsOptional()
  @IsUUID('4')
  lessonId?: string;

  @ApiPropertyOptional({
    description: 'Filtrer par statut',
    enum: ['CREATED', 'IN_PROGRESS', 'SUBMITTED', 'GRADED'],
  })
  @IsOptional()
  @IsIn(['CREATED', 'IN_PROGRESS', 'SUBMITTED', 'GRADED'])
  statusCode?: 'CREATED' | 'IN_PROGRESS' | 'SUBMITTED' | 'GRADED';
}
